/* eslint-disable react/no-unescaped-entities */
import React, { Component, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './mobileCart.css';
import { sendField } from './actions';
import { mycartNavbarHeight } from '../../assets/css/preprocess/global.scss';

import {
  getSession,
  isMoversFlow,
  getLTEUpgrade,
  isOCOFlow,
  isTablet,
  isMobile,
  viewport,
  isEUPFlow,
  isDesktopResolution,
  isComboFlow,
  isExternalFlow,
  isCPCCheckAvailabilityFlow,
  isFuncComp,
  isGlobalHeader,
  getUrlName,
  isJointTransactionFlow,
  isExpressCheckout,
  isECJointTransactionFlow,
  isWHWP2,
  isDesktopResolutionViewPort,
  getAPPID,
  isExpressCheckoutFLow,
} from './Helpers/index';
import { showPage } from '../../services/Cart/actions';
import { getPlansData, getChoiceOfferQualified } from '../../utils/plansReference';

import PageBanner from './PageBanner';
import { getQueryParamByName } from './Helpers/queryParams';
import CallCradleAPI from './RequestAPI';
import { MiniCartWrapper } from './PageHeader.styles';
import MobileViewHeader from './MobileViewHeader';
import { isMVA } from './MVAApiCall';
import { isMiniCartRequired, isMoversPhase3 } from '../Movers/common/utils';
import { getIsStreamlineMiniCartFFlag } from '../NextGen/StreamLineOrder/helpers';

const MobileCart = lazy(() => import('./MiniCart/redesign/mobileCart'));
const FuncMobileCart = lazy(() => import('./MiniCart/funComp/mobileCart'));

class PageHeader extends Component {
  constructor(props) {
    super(props);
    this.isMobile = isMobile();
    this.isTablet = isTablet();
    this.state = {};
  }

  componentDidMount() {
    const pageName = getUrlName(window.location.pathname);
    const { search } = window.location;
    const params = new URLSearchParams(search);
    if (pageName === 'expresscart' && params && (params.has('whwf_redeem') || params.has('whwp_redeem'))) {
      CallCradleAPI('FWA_SalesLanding', pageName);
    } else if (pageName === 'progressiveplan') {
      CallCradleAPI('FWA_ProgressivePlans', pageName);
    }
  }

  isPostCartFunctionalComp = () => {
    if(!isMoversPhase3() && isFuncComp()){
      return true;
    };
    return false;
  };

  render() {
    const type = viewport();
    const isACPEligibile = getQueryParamByName('acp') === 'y';
    const pageName = getUrlName(window.location.pathname);
    const isGlobalHeaderDisplay = isGlobalHeader();

    const isExpressCartPage = pageName === 'expresscart' || false;
    const isPlansOverviewPage = pageName === 'plansOverview' || false;
    const isCartView = (window.vzFlags?.vdsRedesign && pageName === 'cart') || false;
    const isDisplayHeader = type !== 'mfapp' && !isExpressCartPage && !isCPCCheckAvailabilityFlow() && !isComboFlow() && !isExternalFlow();
    const isMobileDevice = this.isMobile || this.isTablet || type === 'mfapp';
    const disableMiniCartPages = [
      'plansOverview',
      'progressiveplan',
      'popularplan',
      'expresscart',
      'confirmation',
      'registration',
      'brtc',
      'streamlineordering',
      'overview',
    ];
    const isDisableMiniCartPage = disableMiniCartPages.includes(pageName);

    const showMiniCart =
      (type === 'mfapp' || !isDesktopResolution()) &&
      (this.props.cartDetails || this.props.dueTodayList) &&
      (isMiniCartRequired() || !isMoversFlow()) &&
      !isDisableMiniCartPage &&
      !isJointTransactionFlow() &&
      !isECJointTransactionFlow();

    const pageRef = document.getElementById('page');
    if (pageRef) {
      pageRef.style.setProperty('--mycart-navbar-height', !showMiniCart ? '0px' : mycartNavbarHeight);
      pageRef.style.setProperty('--express-checkout-mva-flow', isExpressCheckout() && isMVA() ? 'unset' : 'relative');
    }

    const ACPContent = this.props?.acpBannerContent;
    let isSpanishFlow = false;
    if (
      ACPContent &&
      this.props?.acpBannerSpanishContent &&
      (ACPContent.includes('Asequible') || ACPContent.includes('asequible')) &&
      ACPContent.includes('FCC')
    ) {
      isSpanishFlow = true;
    }

    const mobileHeaderTitle = this.props?.plansReferenceData?.MOBILE_VIEW_HEADER_TITLES?.filter(
      (item) => pageName?.toLowerCase() === item?.page?.toLowerCase(),
    );

    const isStreamlineMinicartFFLAG = getIsStreamlineMiniCartFFlag(this.props?.cartDetails?.featureFlags);
    return (
      <>
        {isGlobalHeaderDisplay && <div id="vz-gh20" />}
        {!isGlobalHeaderDisplay && (
          <>
            <header aria-label="Page Header" id={!isPlansOverviewPage && isMobileDevice ? 'progressbarSticky' : ''}>
              {isDisplayHeader && (
                <div>
                  {isPlansOverviewPage && this.props?.acpBannerFlag && !isACPEligibile && (
                    <div
                      className={`u-flexAlignItemsBaseline pad0 acpBannerPadding ${type === 'mfapp' ? 'mvaStretchContainer' : ''}`}
                      style={type === 'tablet' && isEUPFlow() === 'true' ? { marginTop: '30px', marginLeft: '15px' } : {}}
                    >
                      <PageBanner acpBannerContent={isSpanishFlow ? this.props?.acpBannerSpanishContent : this.props?.acpBannerContent} />
                    </div>
                  )}
                </div>
              )}
            </header>
            <>
              {!isStreamlineMinicartFFLAG && showMiniCart && !isExpressCheckoutFLow() && (
                <MiniCartWrapper className="stickyCartClassic">
                  <Suspense fallback={<div />}>
                    <div className="mvaContainer" id={isPlansOverviewPage && isMobileDevice ? 'progressbarSticky' : ''}>
                      {!this.isPostCartFunctionalComp() && (
                        <MobileCart
                          cartValueDetails={this.props.cartDetails}
                          pageStatus={(iscartVisibleVal) => showPage(iscartVisibleVal)}
                          isCartPageView={isCartView}
                          plansReferenceData={this.props.plansReferenceData}
                          history={this.props.history}
                          securityDepositAmt={this.props.securityDepositAmt}
                          taxFeeText={this.props.taxFeeText}
                          disneyPromoHelperText={this.props.disneyPromoHelperText}
                          withAutoPayPreview={this.props.withAutoPayPreview}
                          withAutoPayTooltipDesc={this.props.withAutoPayTooltipDesc}
                          selectedWHWCategory={this.props?.selectedWHWCategory}
                          qualifiedChoiceSpo={this.props?.qualifiedChoiceSpo}
                        />
                      )}
                      {this.isPostCartFunctionalComp() && (
                        <FuncMobileCart {...this.props} pageStatus={(iscartVisibleVal) => showPage(iscartVisibleVal)} isCartPageView={isCartView} />
                      )}
                    </div>
                  </Suspense>
                </MiniCartWrapper>
              )}
              {isExpressCheckoutFLow() && !isDesktopResolutionViewPort() && (
                <MobileViewHeader {...mobileHeaderTitle?.[0]} history={this.props.history} />
              )}
            </>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const cartDetails = state.cartDetails ? state.cartDetails.cartDetailsJson : {};
  const miniCartDetails = state.cartDetails ? state.cartDetails.miniCart : {};
  const miniCartError = state.cartDetails ? state.cartDetails.miniCartError : {};
  const isCartPageView = state.cartDetails ? state.cartDetails.isCartPageView : {};
  const currentView = state.currentView || {};
  const flowType = getSession('FlowType');
  const securityDepositAmt = state.creditCheckDetails?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.fwaSecurityDepositAmount;
  const setup = state.deviceSetup.selectedOption;
  const acctLevelSubscription = state?.checkout?.lineDetails?.acctMcsSubscription;
  const dueTodayAmount = state?.checkout?.orderDetails?.totalDueToday || 0;
  const dueTodayList = state?.checkout?.lineDetails?.lineInfo?.newLine1 || '';
  const dueTodayTaxes = state?.checkout?.orderDetails?.totalTaxAmount || 0;
  const shippingDetails = state?.checkout?.lineDetails?.lineInfo?.newLine1?.shipping || '';
  const dueMontAmount =
    getAPPID() === 'AAL'
      ? state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.newPricePlanInfo?.planPriceWithDiscount || 0
      : state?.checkout?.orderDetails?.totalDueMonthly || 0;
  const dueMonthlyList = state?.checkout?.lineDetails?.subAccountNBSInfo?.[0]?.billAccounts?.[0]?.nbs?.monthlyChargesInfo || '';
  const dueMonthlyProd = state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.newPricePlanInfo || '';
  const dueMonthlyTaxes = state?.checkout?.orderDetails?.totalMonthlyTaxes || 0;
  const dueTodayHomePhoneList = state?.checkout?.lineDetails?.lineInfo?.newLine2;

  const ltePlans = state?.homePlans ? state?.homePlans?.plansJson : '';
  const depletionType = state?.checkout?.depletionType || '';
  const planPerks = state.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.planPerks || [];
  const dueMontTotalAAL = state?.checkout?.cart?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.totalPriceOfPlanAndPerksWithDiscounts || '0';
  const whwDueMontly = state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.selectedFeaturesList?.visFeature?.filter((obj) =>
    obj?.categoryCodes?.[0]?.toLowerCase()?.includes('whwplus'),
  );

  const whwDueToday = state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.selectedFeaturesList?.visFeature?.filter((obj) =>
    obj?.categoryCodes?.[0]?.toLowerCase()?.includes('whwbasic'),
  );
  const selectedWHWCategory = isWHWP2() && state?.addons?.selectedWHWCategory;

  // Removed Schedule support as per the NSADT-99052
  // when user is selected professional setup, the schedule header should be enabled
  if (setup === 'SELF') {
    delete state.progressSteps['Schedule']; //eslint-disable-line
  }
  if ((flowType === 'LTE' || getLTEUpgrade()) && state.progressSteps) {
    if (getLTEUpgrade()) {
      delete state.progressSteps['Add-Ons']; //eslint-disable-line
    }
    delete state.progressSteps['Schedule']; //eslint-disable-line
  }
  if (isOCOFlow() !== undefined && isOCOFlow() === 'true' && state.progressSteps) {
    delete state.progressSteps['Add-Ons']; //eslint-disable-line
  }
  if (flowType === 'LTE' && state.progressStepsMV) {
    delete state.progressStepsMV['Schedule']; //eslint-disable-line
  }
  const progress = state.progressSteps || [];
  const progressMV = state.progressStepsMV || [];
  const plansReferenceData = getPlansData(state.plansReferenceData);
  const cradleValue = state?.SessionValues?.fwaCradleValues;
  const selectedSpecialPromo = state?.progressivePlans?.selectedPlanInfo?.selectedPlan?.selectedSpecialPromo;
  const promotions = state?.checkout?.getCheckoutResponse?.data?.promotions || state?.cartDetails?.cartDetailsJson?.promotions;
  const qualifiedChoiceSpo = getChoiceOfferQualified(promotions, selectedSpecialPromo);

  return {
    urlExtracts: state.UrlExtractsReducer,
    cartDetails,
    isCartPageView,
    progressSteps: progress,
    progressStepsMV: progressMV,
    plansReferenceData,
    currentView,
    securityDepositAmt,
    miniCartDetails,
    miniCartError,
    dueTodayAmount,
    dueTodayList,
    dueTodayTaxes,
    shippingDetails,
    dueMontAmount,
    dueMonthlyList,
    dueMonthlyProd,
    dueMonthlyTaxes,
    dueTodayHomePhoneList,
    ltePlans,
    depletionType,
    cradleValue,
    planPerks,
    whwDueMontly,
    dueMontTotalAAL,
    whwDueToday,
    selectedWHWCategory,
    qualifiedChoiceSpo,
    acctLevelSubscription,
  };
};

const mapDispatchToProps = {
  sendField,
};

PageHeader.propTypes = {
  // title: PropTypes.string,
  cartDetails: PropTypes.object,
  plansReferenceData: PropTypes.object,
  history: PropTypes.object,
  currentView: PropTypes.object,
  securityDepositAmt: PropTypes.any,
  acpBannerContent: PropTypes.string,
  acpBannerSpanishContent: PropTypes.string,
  acpBannerFlag: PropTypes.bool,
  taxFeeText: PropTypes.string,
  dueTodayAmount: PropTypes.number,
  disneyPromoHelperText: PropTypes.string,
  dueTodayList: PropTypes.object,
  dueTodayTaxes: PropTypes.number,
  shippingDetails: PropTypes.string,
  dueMontAmount: PropTypes.number,
  dueMonthlyList: PropTypes.string,
  getShowCartStatus: PropTypes.string,
  dueTodayHomePhoneList: PropTypes.array,
  ltePlans: PropTypes.string,
  dueMonthlyProd: PropTypes.object,
  depletionType: PropTypes.string,
  isSigninLink: PropTypes.bool,
  isSigninPrompt: PropTypes.bool,
  dueMonthlyTaxes: PropTypes.number,
  // cradleValue: PropTypes.string,
  withAutoPayPreview: PropTypes.string,
  withAutoPayTooltipDesc: PropTypes.string,
  planPerks: PropTypes.array,
  whwDueMontly: PropTypes.array,
  dueMontTotalAAL: PropTypes.string,
  selectedWHWCategory: PropTypes.string,
  qualifiedChoiceSpo: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader);
